import { Injectable, Type } from '@angular/core';

import { BaseMatcherEditorComponent } from '../interfaces/base-matcher-editor.component';
import { MatcherComponentRegistry } from '../interfaces/matcher-registry.interface';

/**
 * Implementation of the matcher component registry
 * This service maintains a registry of matcher components without creating circular dependencies
 */
@Injectable({
  providedIn: 'root',
})
export class MatcherComponentRegistryService
  implements MatcherComponentRegistry
{
  private readonly componentRegistry: Record<
    string,
    Type<BaseMatcherEditorComponent>
  > = {};

  /**
   * Register a matcher component with the registry
   * @param matcherName The name of the matcher (e.g., 'contains', 'startsWith')
   * @param componentType The component class to register
   */
  public registerComponent(
    matcherName: string,
    componentType: Type<BaseMatcherEditorComponent>
  ): void {
    this.componentRegistry[matcherName] = componentType;
  }

  /**
   * Get a registered matcher component by name
   * @param matcherName The name of the matcher
   * @returns The component type or undefined if not found
   */
  public getComponent(
    matcherName: string
  ): Type<BaseMatcherEditorComponent> | undefined {
    return this.componentRegistry[matcherName];
  }

  /**
   * Get all registered matcher components
   * @returns Record of matcher names to component types
   */
  public getAllComponents(): Record<string, Type<BaseMatcherEditorComponent>> {
    return { ...this.componentRegistry };
  }
}
